import { render, staticRenderFns } from "./relances.vue?vue&type=template&id=71eb0486&"
import script from "./relances.vue?vue&type=script&lang=js&"
export * from "./relances.vue?vue&type=script&lang=js&"
import style0 from "./relances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports